/**
 * @fileoverview Category data source and type definitions.
 */

import { CategorySchema, type Category } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createCreatedAtField, createDeletedAtField, createLookupEntityFields, createUpdatedAtField } from './field-factories';
import { getCache } from './cache-registry';

export type { Category };

export const categoryDataSource = createBaseDataSource<Category>({
  endpoint: 'category',
  searchField: 'name',
  schema: CategorySchema,
  fields: [
    ...createLookupEntityFields(),
    ...createAccountTrackingFields(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const categoryCache = getCache('category');
